import { NavLink } from 'react-router-dom';
import { useUrlParams } from './hooks/useUrlParams';
import { Dex } from './utils/types';
import './Navbar.css';

interface NavbarProps {
    dex: Dex;
}

export function Navbar({ dex }: NavbarProps) {
    const { bgColor, node, csv, role, sessionId, autoRefresh, autoAction, scannerConnectionIndex } = useUrlParams();

    const commonPages = [
        { path: '/CreateTokenForm', label: 'Token Create', className: 'nav-create-token-form' },
        { path: '/Freezer', label: 'Freezer', className: 'nav-freezer' },
        { path: '/SolManagerCsv', label: 'SOL Manager CSV', className: 'nav-sol-manager-csv' },
        { path: '/TokenManagerCsv', label: 'Token Manager CSV', className: 'nav-token-manager-csv' },
        { path: '/TokenMixerSales', label: 'Token Mixer & Sales', className: 'nav-token-mixer-sales' },
    ];

    const dexPages: Record<Dex, { path: string; label: string; className: string }[]> = {
        pumpswap: [
            { path: '/DeployPoolPumpswap', label: 'Deploy Pool Pumpswap', className: 'nav-deploy-pool' },
            { path: '/VolumeMakerPumpswap', label: 'Volume Maker Pumpswap', className: 'nav-volume-maker-pumpswap' },
            { path: '/VolumeSellerPumpswap', label: 'Volume Seller Pumpswap', className: 'nav-volume-seller-pumpswap' },
            { path: '/RemoveLiquidityPumpswap', label: 'Remove Liquidity Pumpswap', className: 'nav-remove-liquidity-pumpswap' },
            { path: '/RapidLaunchPumpswap', label: 'Rapid Launch Pumpswap', className: 'nav-create-pump-imitation' },
        ],

        raydium: [
            { path: '/CreateMarket', label: 'Create Market', className: 'nav-create-market' },
            { path: '/DeployPool', label: 'Deploy Pool', className: 'nav-deploy-pool' },
            { path: '/LiquidityV3', label: 'Liquidity V3', className: 'nav-liquidity-v3' },
            { path: '/ManualSwap', label: 'Manual Token Swap', className: 'nav-token-swap' },
            { path: '/RapidLaunch', label: 'Rapid Launch', className: 'nav-create-pump-imitation' },
            { path: '/RemoveLiquidity', label: 'Remove Liquidity', className: 'nav-remove-liquidity' },
            { path: '/VolumeMakerV2', label: 'Volume Maker V2', className: 'nav-volume-maker-v2' },
            { path: '/VolumeWalletControl', label: 'Volume Wallet Control', className: 'nav-volume-wallet-control' },
        ],
    };

    return (
        <nav>
            <ul>
                <li>
                    <NavLink
                        className='nav-homepage nav-container'
                        to={`/?bgcolor=${bgColor}&node=${node}&csv=${csv}&role=${role}&sessionId=${sessionId}&autoRefresh=${autoRefresh}&automatization=&autoAction=${autoAction}&scanner-connection-index=${scannerConnectionIndex}`}
                    >
                        <span className='nav-active-effect'></span>
                        <span className='nav-icon'></span>
                    </NavLink>
                </li>

                {commonPages.map(({ path, label, className }) => (
                    <li key={path}>
                        <NavLink
                            className={`${className} nav-container`}
                            to={`${path}?bgcolor=${bgColor}&node=${node}&csv=${csv}&role=${role}&sessionId=${sessionId}&autoRefresh=${autoRefresh}&autoAction=${autoAction}&scanner-connection-index=${scannerConnectionIndex}`}
                        >
                            <span className='nav-active-effect'></span>
                            <span className='nav-icon'></span>
                            <span className='nav-item'>{label}</span>
                        </NavLink>
                    </li>
                ))}

                {dexPages[dex].map(({ path, label, className }) => (
                    <li key={path}>
                        <NavLink
                            className={`${className} nav-container`}
                            to={`${path}?bgcolor=${bgColor}&node=${node}&csv=${csv}&role=${role}&sessionId=${sessionId}&autoRefresh=${autoRefresh}&autoAction=${autoAction}&scanner-connection-index=${scannerConnectionIndex}`}
                        >
                            <span className='nav-active-effect'></span>
                            <span className='nav-icon'></span>
                            <span className='nav-item'>{label}</span>
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
